import script from "./NewCamera.vue?vue&type=script&setup=true&lang=js"
export * from "./NewCamera.vue?vue&type=script&setup=true&lang=js"

import "./NewCamera.vue?vue&type=style&index=0&id=655ded4d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-655ded4d"]])

export default __exports__